import React, { useEffect, useRef } from "react";
import ReactDOM from "react-dom";

const Modal = ({ onClose, title, children }) => {
  
  const ref = useRef();
  
  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        onClose();
      }
    };
    document.addEventListener("click", checkIfClickedOutside);
    return () => {
      document.removeEventListener("click", checkIfClickedOutside);
    };
  }, [onClose]);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
    	document.body.style.overflow = "auto";
    };
  }, []);
  
  return ReactDOM.createPortal(
  	  <div className="modal no-header-modal visible">
			<div className="modal-overlay"></div>
			<div className="modal-content radius-lrg" ref={ref}>
				<a className="close-button" onClick={onClose}>
					<div className="icon-holder round border black no-mg">
						<span className="icon icon-close black"></span>
					</div>
				</a>
				<div className="pd-md">
					<h3 className="pd-r-lrg">{title}</h3>
					{children}
				</div>
			</div>
		</div>,
	
    document.getElementById("modal-root")
  );
};

export default Modal;